import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminOptionsNav } from '../admin-options-nav';
import {
  AdminStatsSectionNav,
  AdminStatsSectionNavItem,
} from '../settings/molecules/admin-stats-section-nav/admin-stats-section-nav';

/**
 * Shell for the Cancellations tab: the admin tab bar, a Dashboard/Responses
 * sub-nav, and the routed body.
 *
 * A routed sub-page rather than a `@switch` case in `AdminOptions`, so a link to
 * one exit survives being pasted into Slack.
 */
@Component({
  selector: 'admin-cancellations',
  imports: [AdminOptionsNav, AdminStatsSectionNav, RouterOutlet],
  templateUrl: './admin-cancellations.html',
  styleUrl: './admin-cancellations.scss',
  host: { class: 'block h-full w-full min-w-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminCancellations {
  readonly navItems: AdminStatsSectionNavItem[] = [
    { label: 'Dashboard', route: '/admin-options/cancellations/dashboard' },
    { label: 'Responses', route: '/admin-options/cancellations/responses' },
  ];
}
